export const GradeColor = {
  A: "#259f00",
  B: "#6dbb00",
  C: "#c1c100",
  D: "#f4b217",
  E: "#fe872c",
  F: "#fd4b4b",
  NONE: '#000000'
};
